import routes from './users.routes';

export const usersModule = {
    routes
};